<template>
  <div>
    <b>{{ labelText }}</b><br />  
    <input
      v-if="field.canEdit"
      type="file"
      @change="onFileChanged"
    />
    <img
      v-if="uploadedFile && field.canEdit"
      :src="uploadedFile"
      width="200"
    />
    <img
      v-else-if="imageFile && field.canRead"
      :src="imageFile"
      width="200"
    />
  </div>
</template>

<script>
import sharedComputed from './../../computed'
import sharedMethods from './../../methods'
import formElementProps from './formElementProps'

export default {
  name: 'FormImage',

  props: {
    ...formElementProps
  },

  data: () => {
    return {
      imageFile: null,
      uploadedFile: null
    }
  },

  computed: {
    ...sharedComputed
  },

  created () {
    this.imageFile = this.value[this.field.fieldName]
    this.value.image = null
  },

  methods: {
    ...sharedMethods,

    onFileChanged (event) {
      let file = event.target.files[0]
      const extension = file.name.split('.').pop()

      if (extension && ['jpg', 'jpeg', 'png'].includes(extension.toLowerCase())) {
        const reader = new FileReader()
        reader.onload = e => {
          this.value[this.field.fieldName] = e.target.result
          this.value[this.field.fieldName + 'Name'] = file.name
          this.value[this.field.fieldName + 'Extention'] = extension
          this.uploadedFile = e.target.result
        }
        reader.readAsDataURL(file)
      }
    }
  }
}
</script>
